import { FC } from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface Props extends ButtonProps {
  loading?: boolean;
}

const ProfileSetupContinueButton: FC<Props> = ({
  disabled,
  loading,
  children,
  ...rest
}) => (
  <Button
    fullWidth
    size="large"
    variant="contained"
    disabled={disabled || loading}
    {...rest}
  >
    {loading ? <CircularProgress size={24} /> : children}
  </Button>
);

export default ProfileSetupContinueButton;
